import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getCanMoveToInaccessibleInbox, getCompanyUrl} from '../../../../store/data/company/companySelectors';
import {getInternalDiscussionRecipientInboxes} from '../../../../store/data/inboxes/inboxesSelectors';
import {getVisibleInboxIds} from '../../../../store/data/preferences/preferencesSelectors';
import {makeGetMentionableTeammatesForNamespace} from '../../../../store/data/teammates/mentionTeammatesSelectors';
import {getUser, getUserNamespace} from '../../../../store/data/teammates/teammatesSelectors';
import {getTeamsByNamespace} from '../../../../store/data/teams/teamsSelectors';
import {getHasLazyTeammatesDropdowns} from '../../../../store/featureFlags/featureFlagsSelectors';
import {InternalRecipientsDropdown} from './internalRecipientsDropdown';

/*
 * Selectors.
 */

const getMentionableTeammates = createSelector(
  [makeGetMentionableTeammatesForNamespace(getUserNamespace), getUser],
  (teammates, user) => teammates.concat(user),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  teamsByNamespace: getTeamsByNamespace,
  availableInboxes: getInternalDiscussionRecipientInboxes,
  user: getUser,
  companyUrl: getCompanyUrl,
  visibleInboxIds: getVisibleInboxIds,
  mentionableTeammates: getMentionableTeammates,
  canMoveToInaccessibleInbox: getCanMoveToInaccessibleInbox,
  hasLazyTeammatesDropdowns: getHasLazyTeammatesDropdowns,
}));

export const InternalRecipientsDropdownContainer = connect(mapStateToProps)(InternalRecipientsDropdown);
